import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const H4Typography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<h4
			ref={ref}
			className={cn(className, 'scroll-m-20 text-lg font-bold', truncate && 'truncate')}
			{...props}
		>
			{children}
		</h4>
	)
);

H4Typography.displayName = 'H4Typography';

export default H4Typography;
